<template>
  <div class="flex flex-col gap-1">
    <OverrideDefaultValue
      v-slot="inputProps"
      :model-value="value"
      :label="label"
      :default-value="defaultValue"
      :formatted-default-value="formattedDefaultValue"
      :initial-overriden-value="initialOverriddenValue"
      :disabled="disabled"
      :error="error"
      :is-loading-default="isLoadingDefault"
      :override-text="overrideText"
      :restore-default-text="restoreDefaultText"
      @update:model-value="setValue($event)"
    >
      <slot v-bind="inputProps" />
    </OverrideDefaultValue>
  </div>
</template>

<script setup lang="ts" generic="T extends 'text' | 'number' | 'boolean' = 'text'">
import { useField } from 'vee-validate';
import { watch } from 'vue';
import OverrideDefaultValue from './OverrideDefaultValue.vue';

type ValueType = T extends 'number' ? number : T extends 'boolean' ? boolean : string;

const props = defineProps<{
  name: string;
  defaultValue: ValueType | null;
  formattedDefaultValue?: string | number | null;
  initialOverriddenValue?: ValueType | null;
  initialValue?: ValueType | null;
  type?: T;
  emptyValueTo?: 'null' | 'undefined';
  disabled?: boolean;
  label?: string;
  isLoadingDefault?: boolean;
  overrideText?: string;
  restoreDefaultText?: string;
}>();

const {
  errorMessage: error,
  value,
  setValue,
} = useField<ValueType | null | undefined>(props.name, undefined, {
  initialValue: props.initialValue,
});

if (props.emptyValueTo) {
  watch(value, (newValue) => {
    const emptyValue = props.emptyValueTo === 'null' ? null : undefined;
    value.value = newValue === '' || newValue === undefined ? emptyValue : newValue;
  });
}
</script>
